import { AbilityBuilder } from '@casl/ability';
import store from './store';
import { ERole } from './lib/enums';

export default AbilityBuilder.define((can) => {
  const currentUser = store.state.currentUser;
  if (!currentUser) {
    return;
  }
  const roles = currentUser.roles;
  if (roles.includes(ERole.project_owner)) {
    can('manage', ['Project', 'Issue', 'Customer']);
  } else if (roles.includes(ERole.project_manager)) {
    can('manage', 'Project', {managers: currentUser._id});
    can('manage', 'Issue', {_creator_id: currentUser._id});
    can('read', 'Customer');
  } else if (roles.includes(ERole.project_employee)) {
    can('read', 'Project', ['epics', 'sprints']);
    can('read', 'Issue', {member: currentUser._id});
    can(
      'update',
      'Issue',
      ['_id', 'title', 'description', 'logworks', 'comments'],
      {member: currentUser._id},
    );
    can('read', 'Customer');
  }
});
